module.exports = __webpack_public_path__ + "media/mode_circulaire/arrow-2_3-c8db45e0.png";